/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Flag_State_DescriptionInputs */



/**
* | output |
* | --- |
* | "Inspections carried out on behalf of flag state authorities." |
*
* @param {Service_Flag_State_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_flag_state_description = /** @type {((inputs?: Service_Flag_State_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Flag_State_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("代表船旗国主管机关开展的检查。")
	return /** @type {LocalizedString} */ ("Inspections carried out on behalf of flag state authorities.")
});